export default function useArticleBookmark () {
  const getAutoBookmarkKey = 'auto-bookmark-article-id';
  const serviceHost = useRuntimeConfig().public.serviceHost;
  const bookmarked = ref(false);
  const oneIdInfo = useCookie('oneid_info');

  const storeBookmarkArticleIdInSession = (articleId: string) => {
    return sessionStorage.setItem(getAutoBookmarkKey, articleId);
  };

  const addToSessionStorage = (articleId: string) => {
    const bookmarkedArticlesInSessionStorage = sessionStorage.getItem('BOOKMARK_ARTICLES');
    if (bookmarkedArticlesInSessionStorage) {
      const bookmarkedArticles = JSON.parse(bookmarkedArticlesInSessionStorage);
      bookmarkedArticles.push({ articleId });
      sessionStorage.removeItem('BOOKMARK_ARTICLES');
      sessionStorage.setItem('BOOKMARK_ARTICLES', JSON.stringify(bookmarkedArticles));
    }
  };

  const addToBookmark = async (articleId: string) => {
    try {
      const serviceClient = await $fetch(`${serviceHost}/v1/leseliste/bookmarks/${articleId}`, {
        method: 'PUT',
        withCredentials: true,
        Accept: 'application/json, text/plain, */*',
        headers: {
          Authentication: oneIdInfo.value || undefined
        }
      });
      if (serviceClient === 'OK') {
        addToSessionStorage(articleId);
      }
    } catch (error) {
      // @ts-ignore
      throw createError(error);
    }
  };

  const removeFromSessionStorage = (articleId: string) => {
    const bookmarkedArticlesInSessionStorage = sessionStorage.getItem('BOOKMARK_ARTICLES');
    if (bookmarkedArticlesInSessionStorage) {
      const bookmarkedArticles = JSON.parse(bookmarkedArticlesInSessionStorage);
      const filteredArticles = bookmarkedArticles.filter((article: any) => article.articleId !== articleId);
      sessionStorage.removeItem('BOOKMARK_ARTICLES');
      sessionStorage.setItem('BOOKMARK_ARTICLES', JSON.stringify(filteredArticles));
    }
  };
  const removeFromBookmark = async (articleId: string) => {
    try {
      const serviceClient = await $fetch(`${serviceHost}/v1/leseliste/bookmarks/${articleId}`, {
        method: 'DELETE',
        withCredentials: true,
        Accept: 'application/json, text/plain, */*',
        body: {},
        headers: {
          Authentication: oneIdInfo.value || undefined
        }
      });
      if (serviceClient === 'OK') {
        removeFromSessionStorage(articleId);
      }
    } catch (error) {
      // @ts-ignore
      throw createError(error);
    }
  };

  const refreshSessionStorage = async () => {
    try {
      const serverClient = await $fetch(`${serviceHost}/v1/leseliste/bookmarks?hits=all&compact=true`, {
        method: 'GET',
        withCredentials: true,
        Accept: 'application/json, text/plain, */*',
        headers: {
          Authentication: oneIdInfo.value || undefined
        }
      });
      if (serverClient && serverClient.teasers) {
        const data = serverClient.teasers.map((item) => {
          return {
            articleId: item.id
          };
        });
        sessionStorage.setItem('BOOKMARK_ARTICLES', JSON.stringify(data));
      }
    } catch (error) {
      throw createError('Failed to read to bookmark');
    }
  };

  const toggleBookmark = async (articleId: string) => {
    if (!oneIdInfo.value) {
      storeBookmarkArticleIdInSession(articleId);
      return;
    }

    bookmarked.value = !bookmarked.value;

    if (bookmarked.value) {
      await addToBookmark(articleId);
    } else {
      await removeFromBookmark(articleId);
    }
  };

  const checkBookmark = async (articleId: string) => {
    if (!oneIdInfo.value) {
      return;
    }

    const bookmarkedArticlesInSessionStorage = sessionStorage.getItem('BOOKMARK_ARTICLES');
    if (bookmarkedArticlesInSessionStorage) {
      const bookmarkedArticles = JSON.parse(bookmarkedArticlesInSessionStorage);
      const result = bookmarkedArticles.filter(item => item.articleId === articleId);
      bookmarked.value = !!(result && result.length > 0);
    } else {
      try {
        const serverClient = await $fetch(`${serviceHost}/v1/leseliste/bookmarks/${articleId}`, {
          method: 'GET',
          withCredentials: true,
          Accept: 'application/json, text/plain, */*',
          headers: {
            Authentication: oneIdInfo.value || undefined
          }
        });
        if (serverClient && serverClient.bookmark) {
          bookmarked.value = serverClient.bookmark;
        } else {
          bookmarked.value = false;
        }
      } catch (e) {
        throw createError(`[${articleId}] Fail to check bookmark status`);
      }
    }
  };

  return {
    bookmarked,
    toggleBookmark,
    checkBookmark,
    refreshSessionStorage
  };
}
